export function normalizeMemberships(raw) {
  if (Array.isArray(raw)) return raw;
  if (raw && Array.isArray(raw.results)) return raw.results;
  if (raw && Array.isArray(raw.memberships)) return raw.memberships;
  return [];
}
